import type { Asset, AssetListResponse } from "../types/asset";
import { api } from "./api";
import { API_URL } from "../config";

export const assetService = {
    /**
     * List assets for a specific reference (e.g., a blog).
     * 
     * @param referenceType - The type of the reference object (e.g., 'blog')
     * @param referenceId - The ID of the reference object
     * @returns A promise that resolves with the list of assets
     */
    list: async (referenceType: string, referenceId: string | number): Promise<Asset[]> => {
        const endpoint = `/assets?reference_type=${referenceType}&reference_id=${referenceId}`;
        const response = await api.get<AssetListResponse>(endpoint);
        const assets = response.data.map((asset) => {
            const suffix = asset.url_suffix.replace(/^\//, "");
            return {
                ...asset,
                url: `${API_URL}/assets/${suffix}`,
            };
        });

        return assets;
    },

    /**
     * Upload an asset for a specific reference (e.g., a blog).
     * 
     * @param referenceType - The type of the reference object (e.g., 'blog')
     * @param referenceId - The ID of the reference object
     * @param file - The file to upload
     * @returns A promise that resolves with the API response
     */
    upload: async (referenceType: string, referenceId: string | number, file: File) => {
        const filename = file.name;
        const endpoint = `/assets/${referenceType}/${referenceId}/${filename}?reference_type=${referenceType}&reference_id=${referenceId}`;

        return api.putBinary<any>(endpoint, file);
    },
};
